import React from "react"
import styled from "@emotion/styled"
import { Box } from "@rebass/grid/emotion"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import gsap from "gsap"
import { useContentfulResults } from "../../hooks/useContentfulResults"
import QuizResurfaceBanner from "../wild/nova/quizresurfacebanner/quizresurfacebanner"
import Hero from "../wild/nova/hero/hero"
import RootCauses from "../wild/nova/rootcauses/rootcauses"
import Manifesto from "../wild/nova/manifesto/manifesto"
import ProductsSection from "../wild/nova/products/productsection"
import Growth from "../wild/nova/growth/growth"
import QuizBanner from "../wild/nova/quizbanner/quizbanner"
import Results from "../wild/nova/results/results"
import DoctorQuotes from "../wild/nova/quotes/doctorquotes"
import Stats from "../wild/nova/stats/stats"
import FaqAccordion from "../wild/nova/faq-accordion"
//import PurposeScroll from "../wild/nova/purposescroll/purposescroll"
import LegalDisclaimer from "../wild/nova/legal-disclaimer"
import Nsfbanner from "../wild/nova/nsf/nsfbanner"

import { data } from "../../data/homepageredesign"

gsap.registerPlugin(ScrollTrigger)

/*
 * to remove NT2-21722, BFCM hero AB test, render only Hero here
 * remove ribbon changes in wild/nova/header/header.js
 */

const HomePageWrap = styled(Box)`
  .vwo24835-variant1,
  .vwo24835-variant2 {
    display: none;
  }
`

const HomePage = ({ cfFaqData }) => {
  const resultsCf = useContentfulResults(data.results.uid) // Pass a single module UID

  return (
    <HomePageWrap>
      <QuizResurfaceBanner />
      <Hero data={data.hero} />
      <RootCauses data={data.rootCauses} />
      {/* <PurposeScroll data={data.purposeScroll} /> */}
      {/* <div id="growth-pin-wrapper"> */}
      <div className={`vwo24835-control`}>
        <Manifesto data={data.manifesto} />
      </div>
      <div className={`vwo24835-variant2`}>
        <Nsfbanner />
      </div>
      <ProductsSection data={data.products} />
      <div className={`vwo24835-variant1`}>
        <Nsfbanner />
      </div>
      <Growth data={data.growth} />
      <QuizBanner />
      {/* </div> */}
      <Results data={resultsCf} />
      <DoctorQuotes data={data.doctorQuotes} />
      <Stats data={data.stats} />
      <FaqAccordion data={cfFaqData} />
      <LegalDisclaimer data={data.references} />
    </HomePageWrap>
  )
}

export default HomePage
